import { t } from '@ankr.com/common';
import loadable from '@loadable/component';
import { Paper } from '@mui/material';

import { Dialog } from 'uiKit/Dialog';
import { PaymentForm } from 'modules/payments/components/PaymentForm';
import { useWindowHeight } from 'hooks/useWindowHeight';
import { featureConfig } from 'modules/common/featureConfig';

import { NoSSRGuard } from '../NoSSRGuard';
import { useUpgradePlanDialogStyles } from './useUpgradePlanDialogStyles';

const Payments = loadable(() =>
  import('modules/payments/screens/Payments').then(module => module.Payments),
);

export interface IUpgradePlanDialogProps {
  onClose: () => void;
  open: boolean;
}

export const UpgradePlanDialog = ({
  onClose,
  open,
}: IUpgradePlanDialogProps) => {
  const windowHeight = useWindowHeight();

  const { classes } = useUpgradePlanDialogStyles({ windowHeight });

  return (
    <NoSSRGuard>
      <Dialog
        className={classes.root}
        classes={{
          container: classes.dialogContainer,
        }}
        keepMounted
        maxPxWidth={620}
        onClose={onClose}
        open={open}
        title={t('account.account-details.top-up.title')}
      >
        {featureConfig.newCryptoPayment ? (
          <Paper className={classes.paymentForm}>
            <Payments />
          </Paper>
        ) : (
          <PaymentForm className={classes.paymentForm} />
        )}
      </Dialog>
    </NoSSRGuard>
  );
};
